export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id=" arrow_style08/down">
<path id="vector" fill-rule="evenodd" clip-rule="evenodd" d="M5.45674 14.1935L15.5206 21.51L25.5845 14.1935V20.8432L15.5206 28.1597L5.45674 20.8432V14.1935ZM5.45674 3L15.5206 10.3164L25.5845 3V9.6497L15.5206 16.9661L5.45674 9.6497V3Z"/>
</g>
</svg>
